import { Component, OnInit } from '@angular/core';
import { Router,NavigationStart,NavigationEnd  }            from '@angular/router';
import { ApplicationContextService }         from './app-context.service';

@Component({
 //   moduleId: module.id,
  selector: 'nav-cmp',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css','./awesome.css']
})
export class NavigationComponent implements OnInit {
   constructor(
    private appContextService: ApplicationContextService,
    private router: Router) {
      
      // router.events.forEach((event) => {
      //   if(event instanceof NavigationStart) {
      //             document.getElementById("submenu1").style.display="none";
      //             document.getElementById("submenu2").style.display="none";
      //             document.getElementById("submenu3").style.display="none";
      //             document.getElementById("submenu4").style.display="none";
      //             console.log('zacatek');
      // }
        // if(event instanceof NavigationEnd) {
        
        //             document.getElementById("submenu1").style.display="";
        //           document.getElementById("submenu2").style.display="";
        //           document.getElementById("submenu3").style.display="";
        //           document.getElementById("submenu4").style.display="";
        //           console.log('konec');
        // }
        // NavigationEnd
        // NavigationCancel
        // NavigationError
        // RoutesRecognized
      // });
       
    }

  ngOnInit(): void {

    
  }
  visibleSubMenu(ord: Number, show: Boolean, stayActive: Boolean): void {
    if (show == true) {
       document.getElementById("submenu"+ord).style.display="block";
    }
    else {
      document.getElementById("submenu"+ord).style.display="none";
      // if (stayActive) {
      //     document.getElementById("menu1").classList.remove('dim');   
      //     document.getElementById("menu2").classList.remove('dim');   
      //     document.getElementById("menu3").classList.remove('dim');   
      //     document.getElementById("menu4").classList.remove('dim');   

      //     document.getElementById("menu"+ord).classList.add('dim');   
    
      // }
    }

  }
 

}
